<wr-new-data-table headerText="Gebäude"
                   localStorageIdentifier="contractor-building-overview"
                   [loadItemsFunction]="loadBuildings"
                   [getCountFunction]="getCount"
                   (lineClick)="navigateToBuilding($event)"
                   [form]="form"
                   [isAdmin]="false">
  <ng-template dataTableFilter>
    <form [formGroup]="form">
      <div class="filter-form">
        <div class="filter-control-group">
          <label class="label" for="textFilter">Textfilter</label>
          <input type="text" nbInput id="textFilter" formControlName="fullTextSearch" placeholder="Filter Text...">
        </div>
        <div class="filter-control-group">
          <label class="label" for="tenantSelect">Kunden</label>
          <wr-fixed-tenant-select id="tenantSelect"
                                  formControlName="ownerTenant"
                                  [tenants]="fixedTenants()"
                                  [showEmptyOption]="true"></wr-fixed-tenant-select>
        </div>
      </div>
    </form>
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="sectionText"
    exportKey="baseData.sectionText"
    display="Adresse">
    @if (building.baseData.sectionText) {
      <div>
        {{building.baseData.sectionText}}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="name"
    exportKey="baseData.name"
    display="Name">
    @if (building.baseData.name) {
      <div>
        {{building.baseData.name}}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="ownerTenant"
    exportKey="ownerTenant.name"
    display="Kunde">
    <wr-tenant-badge [tenant]="building.ownerTenant"></wr-tenant-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="region"
    [sortable]="false"
    exportKey="team.region.name"
    display="Bereich">
    <wr-region-badge [region]="building.team?.region"></wr-region-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="team"
    [sortable]="false"
    exportKey="team.name"
    display="Team">
    <wr-team-badge [team]="building.team"></wr-team-badge>
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="internalNumber"
    display="Int. Nummer">
    @if (building.internalNumber) {
      <div>
        {{building.internalNumber}}
      </div>
    }
  </ng-template>
  <ng-template
    dataColumn
    let-building
    key="area"
    exportKey="baseData.area"
    [exportDecimals]="2"
    display="Fläche">
    @if (building.baseData.area) {
      <div>
        {{building.baseData.area | number: '1.2-2'}} m²
      </div>
    }
  </ng-template>
</wr-new-data-table>
